import SharePointUploader from 'components/SharePointUploader'
import { useCheckPermission } from 'hooks/useCheckPermission'
import { Permission, SharePointParentFolder } from '@cims-online/shared'
import { ConcreteTestSet } from '../ConcreteTestSetTrackerContext/types'
import { CIMSModalWrapperProps } from 'components/CIMSModal/types'
import FormlessModal from 'components/CIMSModal/FormlessModal'

const UploadModal: React.FC<CIMSModalWrapperProps<ConcreteTestSet>> = ({
  visible,
  onClose,
  state,
}) => {
  const canRemove = useCheckPermission(Permission.RemoveConcretePacketFile)
  if (!state?.testSetId) return null
  return (
    <FormlessModal
      title="Upload Additional Files"
      visible={visible}
      cancel={{ fn: onClose }}
      ok={false}
    >
      <SharePointUploader
        parent={SharePointParentFolder.ConcretePackets}
        folder={state?.testSetId}
        sharePointResourceList={{
          preventDelete: !canRemove,
          exclude: ({ id }) => id === state?.packetSharePointResource?.id,
        }}
        permittedFileExtensions={['jpeg', 'png', 'jpg', 'pdf']}
        permittedFileTypes={[
          'image/jpeg',
          'image/jpg',
          'image/png',
          'application/pdf',
        ]}
      />
    </FormlessModal>
  )
}

export default UploadModal
